module.exports = __webpack_public_path__ + "img/1296.cc9709f9.gif";